"use strict";
"use client";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tags = Tags;
exports.TagsContent = TagsContent;
exports.TagsEmpty = TagsEmpty;
exports.TagsGroup = TagsGroup;
exports.TagsInput = TagsInput;
exports.TagsItem = TagsItem;
exports.TagsList = TagsList;
exports.TagsSelectedValue = TagsSelectedValue;
exports.TagsTrigger = TagsTrigger;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _reactUseControllableState = require("@radix-ui/react-use-controllable-state");
var _utils = require("@design/lib/utils");
var _badge = require("@design/ui/badge");
var _button = require("@design/ui/button");
var _command = require("@design/ui/command");
var _popover = require("@design/ui/popover");
var _lucideReact = require("lucide-react");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "children"],
  _excluded2 = ["className", "children", "onRemove"],
  _excluded3 = ["className", "children", "shouldFilter"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["children", "className"],
  _excluded7 = ["className"],
  _excluded8 = ["children", "className", "selected"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var TagsContext = /*#__PURE__*/(0, _react.createContext)({
  value: undefined,
  setValue: undefined,
  open: false,
  onOpenChange: function onOpenChange() {},
  width: undefined,
  setWidth: undefined
});
function useTagsContext() {
  var context = (0, _react.useContext)(TagsContext);
  if (!context) {
    throw new Error("useTagsContext must be used within a TagsProvider");
  }
  return context;
}
function Tags(_ref) {
  var value = _ref.value,
    setValue = _ref.setValue,
    controlledOpen = _ref.open,
    controlledOnOpenChange = _ref.onOpenChange,
    modal = _ref.modal,
    children = _ref.children,
    className = _ref.className;
  var _useControllableState = (0, _reactUseControllableState.useControllableState)({
      prop: controlledOpen,
      defaultProp: false,
      onChange: controlledOnOpenChange
    }),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    open = _useControllableState2[0],
    setOpen = _useControllableState2[1];
  var _useState = (0, _react.useState)(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (!ref.current) {
      return;
    }
    var resizeObserver = new ResizeObserver(function (entries) {
      setWidth(entries[0].contentRect.width);
    });
    resizeObserver.observe(ref.current);
    return function () {
      resizeObserver.disconnect();
    };
  }, [setWidth]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(TagsContext.Provider, {
    value: {
      value: value,
      setValue: setValue,
      open: open,
      onOpenChange: setOpen,
      width: width,
      setWidth: setWidth
    },
    "data-sentry-element": "TagsContext.Provider",
    "data-sentry-component": "Tags",
    "data-sentry-source-file": "tags.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.Popover, {
      modal: modal,
      onOpenChange: setOpen,
      open: open,
      "data-sentry-element": "Popover",
      "data-sentry-source-file": "tags.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        "data-slot": "tags",
        "data-state": open ? "open" : "closed",
        className: (0, _utils.cn)("relative w-full max-w-xs min-w-48", className),
        ref: ref,
        children: children
      })
    })
  });
}
function TagsTrigger(_ref2) {
  var className = _ref2.className,
    children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded);
  var _useTagsContext = useTagsContext(),
    open = _useTagsContext.open;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.PopoverTrigger, {
    asChild: true,
    "data-sentry-element": "PopoverTrigger",
    "data-sentry-component": "TagsTrigger",
    "data-sentry-source-file": "tags.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, _objectSpread(_objectSpread({
      "data-slot": "tags-trigger",
      "data-state": open ? "open" : "closed",
      className: (0, _utils.cn)("group h-auto min-h-9 w-full items-center justify-baseline px-3 py-2", className),
      role: "combobox",
      "aria-expanded": open,
      variant: "outline"
    }, props), {}, {
      "data-sentry-element": "Button",
      "data-sentry-source-file": "tags.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "flex flex-wrap items-center gap-1",
        children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "py-px text-sm text-muted-foreground group-has-data-[slot=tags-selected-value]:pl-1",
          children: "Select a tag..."
        })]
      })
    }))
  });
}
function TagsSelectedValue(_ref3) {
  var className = _ref3.className,
    children = _ref3.children,
    onRemove = _ref3.onRemove,
    props = _objectWithoutProperties(_ref3, _excluded2);
  var handleRemove = function handleRemove(event) {
    event.preventDefault();
    event.stopPropagation();
    onRemove === null || onRemove === void 0 || onRemove();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_badge.Badge, _objectSpread(_objectSpread({
    "data-slot": "tags-selected-value",
    className: (0, _utils.cn)("group/tags-value flex cursor-default items-center gap-1 text-xs", className)
  }, props), {}, {
    "data-sentry-element": "Badge",
    "data-sentry-component": "TagsSelectedValue",
    "data-sentry-source-file": "tags.tsx",
    children: [children, onRemove && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      "data-slot": "tags-remove-button",
      className: (0, _utils.cn)("pointer-events-auto size-auto shrink-0 cursor-pointer transition-all outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50"),
      type: "button",
      onClick: handleRemove,
      "aria-label": "Remove tag",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_lucideReact.XIcon, {
        className: "pointer-events-none size-3 shrink-0 transition-opacity group-hover/tags-value:opacity-80"
      })
    })]
  }));
}
function TagsContent(_ref4) {
  var className = _ref4.className,
    children = _ref4.children,
    shouldFilter = _ref4.shouldFilter,
    props = _objectWithoutProperties(_ref4, _excluded3);
  var _useTagsContext2 = useTagsContext(),
    width = _useTagsContext2.width;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_popover.PopoverContent, _objectSpread(_objectSpread({
    "data-slot": "tags-content",
    className: (0, _utils.cn)("p-0", className),
    style: {
      width: width
    }
  }, props), {}, {
    "data-sentry-element": "PopoverContent",
    "data-sentry-component": "TagsContent",
    "data-sentry-source-file": "tags.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_command.Command, {
      shouldFilter: shouldFilter,
      "data-sentry-element": "Command",
      "data-sentry-source-file": "tags.tsx",
      children: children
    })
  }));
}
function TagsInput(_ref5) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded4);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandInput, _objectSpread(_objectSpread({
    "data-slot": "tags-input",
    className: (0, _utils.cn)("h-10 py-2.5", className)
  }, props), {}, {
    "data-sentry-element": "CommandInput",
    "data-sentry-component": "TagsInput",
    "data-sentry-source-file": "tags.tsx"
  }));
}
function TagsList(_ref6) {
  var className = _ref6.className,
    props = _objectWithoutProperties(_ref6, _excluded5);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandList, _objectSpread(_objectSpread({
    "data-slot": "tags-list",
    className: (0, _utils.cn)("max-h-[300px]", className)
  }, props), {}, {
    "data-sentry-element": "CommandList",
    "data-sentry-component": "TagsList",
    "data-sentry-source-file": "tags.tsx"
  }));
}
function TagsEmpty(_ref7) {
  var children = _ref7.children,
    className = _ref7.className,
    props = _objectWithoutProperties(_ref7, _excluded6);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandEmpty, _objectSpread(_objectSpread({
    "data-slot": "tags-empty"
  }, props), {}, {
    "data-sentry-element": "CommandEmpty",
    "data-sentry-component": "TagsEmpty",
    "data-sentry-source-file": "tags.tsx",
    children: children !== null && children !== void 0 ? children : "No tags found."
  }));
}
function TagsGroup(_ref8) {
  var className = _ref8.className,
    props = _objectWithoutProperties(_ref8, _excluded7);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandGroup, _objectSpread(_objectSpread({
    "data-slot": "tags-group",
    className: (0, _utils.cn)("py-1.5", className)
  }, props), {}, {
    "data-sentry-element": "CommandGroup",
    "data-sentry-component": "TagsGroup",
    "data-sentry-source-file": "tags.tsx"
  }));
}
function TagsItem(_ref9) {
  var children = _ref9.children,
    className = _ref9.className,
    selected = _ref9.selected,
    props = _objectWithoutProperties(_ref9, _excluded8);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_command.CommandItem, _objectSpread(_objectSpread({
    "data-checked": selected ? "true" : undefined,
    "data-slot": "tags-item",
    "data-selected": selected ? "true" : undefined,
    className: (0, _utils.cn)("cursor-pointer items-center justify-between gap-2 [&>svg:not([class*='size-'])]:size-4 [&>svg:not([class*='text-'])]:text-popover-foreground", className)
  }, props), {}, {
    "data-sentry-element": "CommandItem",
    "data-sentry-component": "TagsItem",
    "data-sentry-source-file": "tags.tsx",
    children: children
  }));
}